var exports = {
  "AS": "item__rruuKe",
  "Kk": "icon__lClXIt",
  "R_": "heading__f5SDdZ",
  "Ij": "fullWidth__QABc_7",
};

module.exports = exports;
